import KonfigurasiAuth from "../../../../../../components/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigAuth"
export default function Home() {
  
  return (
    <KonfigurasiAuth />
  );
}
